/**
 * 当前语言订阅 Hook
 * 基于 i18next 的 languageChanged 事件，配合 useSyncExternalStore 保证组件在切换语言时重渲染。
 */
import { useSyncExternalStore } from "react"

import {
  type LocaleCode,
  changeLocale,
  getLang,
  getPageLocales,
} from "@/shared/i18n"
import i18n from "i18next"

/** 在当前页面支持的语言里循环取下一个（供两语切换按钮使用） */
function nextLocale(current: LocaleCode): LocaleCode {
  const list = getPageLocales()
  const index = list.indexOf(current)
  return list[(index + 1) % list.length] ?? "en_US"
}

export function useLocale() {
  const locale = useSyncExternalStore(
    (cb) => {
      i18n.on("languageChanged", cb)
      return () => i18n.off("languageChanged", cb)
    },
    () => getLang(),
    () => getLang(),
  )

  const next = nextLocale(locale)

  return {
    locale,
    /** 当前页面支持的语言列表 */
    locales: getPageLocales(),
    /** 循环切换的下一个语言，供切换按钮展示目标语言名 */
    next,
    setLocale: changeLocale,
    toggle: () => changeLocale(next),
  }
}

export type { LocaleCode }
